import { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";

import { CommentHeaderProps } from "../../../../types/components/props.type";
import { CommentOptionButtonIcon } from "../../../../assets/icons/create-feed";
import { CommentMenu } from "./CommentMenu";

export const CommentHeader = ({
  authorFullName,
  authorRole,
  authorClub,
  authorId,
  commentId,
  postId,
}: CommentHeaderProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick} sx={{ position: "absolute", top: 0, right: 0 }}>
        <CommentOptionButtonIcon />
      </IconButton>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "24px",
          }}
        >
          {authorFullName}
        </Typography>
        <Typography
          sx={{
            color: "var(--Dark---600, #707070)",
            fontFamily: "Montserrat",
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "18px",
          }}
        >
          {authorRole}
          {authorRole && authorClub && " . "}
          {authorClub}
        </Typography>
      </Box>

      <CommentMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        authorFullName={authorFullName}
        authorId={authorId}
        commentId={commentId}
        postId={postId}
      />
    </>
  );
};

export default CommentHeader;
